import HeaderWrapper from '@/components/common/Header/HeaderWrapper';
import { getRoutes } from '@/routes/routePaths';
import { SessionStatus } from '@/Types/gql/graphql';
import { authState } from '@/vars/auth';
import { useQuery, useReactiveVar } from '@apollo/client';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { GET_ALL_SESSIONS } from '../sessions/GraphQl/queries';
import SessionCard from './SessionCard';

const PendingFeedback = () => {
  const { userDetails } = useReactiveVar(authState);

  const { data, loading } = useQuery(GET_ALL_SESSIONS, {
    variables: {
      limit: 30,
      offset: 0,
      sort: {
        sessionStartTime: -1,
      },
      filter: {
        traineeId: userDetails?._id,
        sessionStatus: SessionStatus.Completed,
        trainerExpertiseRating: null,
      },
    },
    fetchPolicy: 'network-only',
  });

  return (
    <div>
      <HeaderWrapper>
        <div className='flex items-center gap-2'>
          <Link to={getRoutes.Sessions}>
            <ArrowLeft className='h-5 w-5' />
          </Link>
          <h1 className='text-lg font-semibold'>Pending Reviews</h1>
        </div>
      </HeaderWrapper>
      <div id='sessions' className='flex flex-col container py-14 w-[1060px] max-w-[98%] gap-4'>
        <h3 className='font-semibold'>
          {data?.getAllSessionCount || 0} Pending{' '}
          {data && data?.getAllSessionCount > 1 ? 'Reviews' : 'Review'}
        </h3>
        <h5 className='font-normal text-[#A8ADB9]'>
          Let us know how your sessions went! Share your feedback to help us improve your training
          experience.
        </h5>
        {!loading &&
          data?.getAllSession?.map((session, index) => {
            if (session) {
              return (
                <SessionCard
                  id={session._id}
                  key={index}
                  sessionId={session.sessionUniqId || ''}
                  trainer={session.trainerIdUser ? session.trainerIdUser?.firstName || '' : ''}
                  trainerImage={session.trainerIdUser?.profileImage || ''}
                  isCompleted={true}
                  title={session.trainingType?.title || ''}
                  program={session.programName || ''}
                  sessionEnd={session?.sessionEndTime}
                  sessionStart={session?.sessionStartTime}
                />
              );
            }
          })}
      </div>
    </div>
  );
};

export default PendingFeedback;
